import React from 'react';
import PropTypes from 'prop-types';
import Skeleton from 'react-loading-skeleton';
import Avatar from '../../avatar/avatar';
import vahoy from '../../../javascript/vahoy';
import FollowButton from '../../follow_button';
import SmartSnippet from '../../algolia_search/smart_snippet_v1';

function WelcomeCard({ sourceRequest, hasManyPitches }) {
  const reporterName = sourceRequest.reporter?.name || 'this journalist';
  const trackClicks = () => {
    vahoy.track('SourceRequests/WelcomeCard#clickCollaborateWith');
  };
  return (
    <div className="d-flex flex-column justify-content-between overflow-hidden h-100">
      <div className="d-flex justify-content-start p-2 border-bottom bg-gray-100">
        <Avatar
          avatarUrl={sourceRequest.reporter?.avatar_url}
          sizeClass="avatar me-3"
          avatarLetters={sourceRequest.reporter?.initials}
        />
       <div className="d-flex flex-column justify-content-center align-items-start">
          <h4 className="text-dark font-size-16px m-0">
            {sourceRequest.reporter?.name || <Skeleton width={120} />}
          </h4>
          <h6 className="text-muted m-0 font-size-14px text-start mb-1">Journalist</h6>
          <span className="font-size-12px">
            <FollowButton
              favoriteableId={sourceRequest.reporter?.id}
              favoriteableType="Reporter"
              favoriteId={sourceRequest.reporter?.favorite_id}
              favorited={sourceRequest.reporter?.favorited}
              ahoyObjectGid={sourceRequest.reporter?.id}
              showTooltip={true}
              tooltipId={sourceRequest.reporter?.id}
              tooltipText="Reporters will be notified of the follow and be offered a chance to connect with you!"
              page="Welcome Card"
              key={sourceRequest.reporter?.id}
            />
          </span>
        </div>
      </div>
      <div className="p-2">
        <div className="d-flex align-items-center border-bottom pb-2">
          <h4 className="text-muted m-0 font-size-14px flex-shrink-0"> Contributor to: </h4>
          <div className="ms-2" style={{ minWidth: 0, overflow: 'hidden' }}>
            <img
              alt={sourceRequest.publication.name}
              src={sourceRequest.publication.logo_url}
              style={{
                maxHeight: '35px',
                maxWidth: '100%',
                width: 'auto',
                height: 'auto',
                objectFit: 'contain',
              }}
            />
          </div>
        </div>
      </div>
      <div className="d-flex flex-column justify-content-between p-2 flex-grow-1">
        <div className="m-0 p-0">
          <p className="text-muted mb-2 font-size-14px">A little about {reporterName}...</p>
          <p className="font-size-14px text-dark mb-0">
            <SmartSnippet attribute="details" hit={sourceRequest} truncateLength={65} />
          </p>
        </div>
        { !hasManyPitches && (
          <div className="d-flex align-items-center justify-content-center mt-1 mb-3">
            <a
              className="btn btn-primary btn-lg font-size-14px"
              style={{ width: '95%' }}
              href={sourceRequest.source_request_path}
              onClick={trackClicks}
            >
              <i className="fas fa-message me-1" /> Collaborate with {reporterName}
            </a>
          </div>
        )}
      </div>
    </div>
  );
}

WelcomeCard.propTypes = {
  sourceRequest: PropTypes.instanceOf(Object),
  hasManyPitches: PropTypes.bool,
};

WelcomeCard.defaultProps = {
  sourceRequest: undefined,
  hasManyPitches: false,
};

export default WelcomeCard;
